<template>
    <div class="visibility-config-card">
        <div class="visibility-header-row">
            <input-search class="visibility-action-search" @getData="getSearch" />
            <div class="visibility-actions-row">
                <button 
                    class="btn btn-sm bg-white fw-400"
                    style="
                        color: black !important;  
                        border: 1px solid black !important
                    "
                    @click="viewConfig('','config-visibility-options','Configuración','Establece la visibilidad para varios productos de manera simultánea')"
                >
                    Configuración en lote
                </button>
                <button 
                    class="btn fw-500 button-export text-white rounder-8 button-products d-flex align-items-center"
                    @click="exportDataFile"
                >
                    <img src="/icons/down.svg" alt="icono" class="me-1 icons">Exportar
                </button>
            </div>
        </div>

        <div class="visibility-table-info-row">
            <span 
                class="visibility-total-count"
                v-if="totalCount > 0 && !loading"
            >
                Total: {{ totalCount }}
            </span>
        </div>
        <div class="table-responsive border" v-if="products.length > 0 || loading">
            <placeholder v-if="loading" :type="'table'" :count="3"/>
            <table class="visibility-table w-100" v-else>
                <thead>
                    <tr>
                        <th
                            v-for="column in headerColumns"
                            :key="column.key"
                            :colspan="column.colspan || 1"
                        >
                            {{ getColumnLabel(column.key) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(product, index) in products" :key="index"
                    >
                        <td
                            v-for="column in visibleColumns"
                            :key="column.key"
                        >
                            <span v-if="column.key === 'sku'" class="visibility-sku-badge">{{ product.sku }}</span>
                            <span v-else-if="column.key === 'long_name'">{{ product.long_name }}</span>
                            <span v-else-if="column.key === 'store_name'">{{ product.store_name }}</span>
                            <span v-else-if="column.key === 'visibility_number'" class="visibility-value-text">{{ product.visibility_number }}</span>
                            <span v-else-if="column.key === 'visibility'" class="visibility-value-text">{{ product.visibility || '—' }}</span>
                            <div v-else-if="column.key === 'actions'" class="d-flex flex-column gap-1">
                                <span
                                    @click="viewConfig(product,'config-visibility-one','Configuración','Establece la visibilidad para el producto seleccionado')"
                                >
                                    <img class="cursor-pointer" src="/icons/pencil-margin.svg" alt="Editar"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- No data message -->
        <div v-if="products.length <= 0 && !loading" class="p-4 bg-white rounder-8 border border-1 text-center">
            <h4 class="fw-400 size-18 text-secondary">No existe información para mostrar</h4>
        </div>

        <PaginationControls
            v-if="totalCount > 0"
            :current-page="currentPage"
            :total-count="totalCount"
            :page-size="pageSize"
            @change-page="$emit('change-page', $event)"
            @change-page-size="$emit('change-page-size', $event)"
        />
    </div>
</template>

<script>
import { mapGetters,mapActions} from 'vuex'
import inputSearch from '@/components/inputSearch.vue';
import Placeholder from "../../../../../components/loadings/placeholder.vue";
import PaginationControls from "../../../../../components/PaginationControls.vue";
import configsRecTableMixin from '../mixins/configsRecTableMixin.js'
export default {
    name: 'table-visibility-config',
    mixins: [configsRecTableMixin],
    components: {
        inputSearch,
        Placeholder,
        PaginationControls
    },
    props:{
        products: {
            type: Array,
            required: true,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        totalCount: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 25
        }
    },
    data(){
        return {
            search_product: '',
            search_type: 'codigo',
            tableConfigKey: 'visibility'
        }
    },
    computed: {
        ...mapGetters([
            "authentication_user",
            "activeDesk"
        ]),
        headerColumns() {
            const columns = [];
            this.visibleColumns.forEach((column) => {
                if (column.group && column.hidden_header) return;
                if (column.group) {
                    const groupCount = this.visibleColumns.filter(c => c.group === column.group).length;
                    columns.push({ ...column, colspan: groupCount });
                } else {
                    columns.push(column);
                }
            });
            return columns;
        },
        tableWrapperClass() {
            return {
                'table-wrapper-fixed': true,
                'table-wrapper-expanded': !this.activeDesk,
                'table-wrapper-with-sidebar': this.activeDesk
            }
        }
    },
    methods: {
        ...mapActions(["executeCommit","get"]),
        getSearch(row){
            this.search_product = row.search
            this.search_type = row.searchType
            this.$emit('getData', 
                this.search_product,
                this.search_type
            )
        },
        viewConfig(row,name,title,text){
            this.$emit('viewModal', row, name, title, text);
        },
        exportDataFile() {
            this.executeCommit({ mutation: "loading_state_component" });
            let url = `/api/products/export_config_visibility/`;
            if (!this.authentication_user.client_channel){
                url = url + `?business=${this.authentication_user.client_business_select}`
            }
            this.get({
                url: url,
            }).then(() => {
                this.executeCommit({ mutation: "loading_state_component" });
                this.$notification.success(
                    "En un momento te llegará un correo electrónico con los datos de configuración de visibilidad",
                    { timer: 10, showCloseIcn: true }
                );
            });
        },
    }
}
</script>

<style scoped>
.visibility-config-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.visibility-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 1.25rem;
}

.visibility-actions-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
    flex: 0 1 auto;
    max-width: 100%;
}

.visibility-actions-row .btn {
    height: 44.8px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.visibility-table-info-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
}

.visibility-total-count {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
}

.visibility-action-search {
    flex: 1 1 250px;
    min-width: 0;
}

.visibility-action-search :deep(.search-container-wrapper),
.visibility-action-search ::v-deep .search-container-wrapper,
.visibility-action-search /deep/ .search-container-wrapper {
    width: 100%;
    max-width: none;
}

.visibility-action-search ::v-deep .search-wrapper,
.visibility-action-search /deep/ .search-wrapper {
    width: 100%;
}

@media (max-width: 991.98px) {
    .visibility-actions-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        align-items: stretch;
    }

    .visibility-actions-row > * {
        box-sizing: border-box;
        min-width: 0;
        width: 100%;
    }

    .visibility-actions-row .btn {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}

@media (max-width: 575.98px) {
    .visibility-actions-row {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.4rem;
    }
}

.visibility-table {
    border-collapse: collapse;
    font-size: 0.85rem;
}

.visibility-table thead th {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.03em;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    background-color: #F3F4F6;
}

.visibility-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    color: #1f2937;
}

.visibility-table tbody tr:hover {
    background: #fafafa;
}

.visibility-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
}

.visibility-value-text {
    color: #374151;
    font-size: 0.85rem;
}

.button-export {
    background-color: #021418;
}

.button-products {
    padding: 10.5px 20px !important;
}

.icons {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
}
</style>
